<template>
  <div class="main-container">
    <div class="error-image">
      <img src="../assets/icons/warning.svg" alt="warning" />
    </div>
    <div class="error-title">
      <h3>{{ errorTitleText }}</h3>
    </div>
    <div v-if="errorDescriptionText" class="error-subtitle">
      <span>
        {{ errorDescriptionText }}
      </span>
    </div>
    <div class="button-container">
      <button
        v-if="closeButtonText"
        id="errorMessageCloseButton"
        class="primary"
        @click.stop="closeButtonHandler"
      >
        {{ closeButtonText }}
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import {useI18n} from "vue-i18n";
import {computed, defineComponent} from "vue";
import {AnalyticEventsNames,} from "@/helpers/google-analytics.helpers";
import {useStore} from "vuex";
import authHelper from "@/helpers/authHelper";
import {ActionLogTypeConst} from "@/types/IActionLogs";

export default defineComponent({
  name: "ErrorMessage",
  props: {
    countryProp: {
      type: String,
      default: ""
    },
    errorTitle: {
      type: String,
      default: ""
    },
    errorDescription: {
      type: String,
      default: null
    },
    closeButtonText: {
      type: String,
      default: ""
    }
  },
  emits: ["close-button-click"],
  setup(props) {
    const {t} = useI18n();
    const store = useStore();
    const country = computed(
      () => store.state.payOptions.deviceInfo.country ? store.state.payOptions.deviceInfo.country : props.countryProp
    );
    const deviceTag = computed(
        () => store.state.payOptions.deviceInfo.deviceTag
    );
    const errorTitleText = computed(
        () => props.errorTitle ? props.errorTitle : t("unexpected-error")
    );
    const errorDescriptionText = computed(
        () => props.errorDescription !== null ? props.errorDescription : t("try-again-please")
    );

    return {
      t,
      store,
      country,
      deviceTag,
      errorTitleText,
      errorDescriptionText
    };
  },
  mounted() {
    if (process.env.VUE_APP_USE_ACTION_LOGS === "true") {
      // Log the event on page view
      authHelper.logAction({
        deviceTag: this.deviceTag,
        country: this.country,
        action: AnalyticEventsNames.OnFullyPaidPage,
        actionType: ActionLogTypeConst.PAGE_VIEW
      }, this.$gtag)
    }
  },
  beforeUnmount() {
    if (process.env.VUE_APP_USE_ACTION_LOGS === "true") {
      // Log the event on page unmount
      authHelper.logAction({
        deviceTag: this.deviceTag,
        country: this.country,
        action: AnalyticEventsNames.OnFullyPaidPage_BrowserClose,
        actionType: ActionLogTypeConst.PAGE_VIEW
      }, this.$gtag)
    }
  },
  methods: {
    closeButtonHandler() {
      this.$emit("close-button-click");
    }
  }
});
</script>
<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 32px);
  padding: 16px;
  text-align: center;
}

.error-subtitle {
  color: var(--Typography-Text-2);
  padding-bottom: 36px;
}

.button-container {
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: column;
}
</style>
